import { SettingsDisplay } from "@smartship-services/ui";

const SettingsPage = () => {
  return <SettingsDisplay />;
};
export default SettingsPage;
